<template>
    <el-drawer title="查看绑定演出" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <h3 v-if="info" class="info color-danger">{{ info.name }}（ID：{{ info.id }}）</h3>
            <div class="page-list-box">
                <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                    <el-table-column prop="id" label="演出ID"></el-table-column>
                    <el-table-column prop="title" label="演出名称" min-width="150"></el-table-column>
                    <el-table-column prop="startTime" label="开演时间" min-width="150"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="unbind(scope.row.id)">解除绑定
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="data" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div>
        </div>

        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultParams = {
    pageNo: 1,
    hotelId: '',
}
export default {
    data() {
        return {
            drawerShow: false,
            listLoading: false,
            data: null,
            dataList: [],
            info: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
        }
    },
    methods: {
        close() {
            this.dataList = [];
            this.data = null;
            this.drawerShow = false;
            this.listLoading = false;
            this.params = {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            }
        },
        show(obj) {
            this.info = obj;
            this.params.hotelId = obj.id;
            this.getDataList();
            this.drawerShow = true;
        },
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/hotel/activityList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //重置搜索
        // reset() {
        //     this.params = {
        //         ...defaultParams,
        //         pageSize: this.params.pageSize,
        //     };
        //     this.getDataList();
        // },
        unbind(id) {
            this.$confirm('是否确认解除对该演出的绑定？', '提示', {
                center: true
            }).then(() => {
                this.$request({
                    url: "/hotel/unbind",
                    method: "POST",
                    params: {
                        hotelId: this.info.id,
                        activityId: id
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.params.pageNo = 1;
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            }).catch(() => { })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>